module.exports = __webpack_public_path__ + "static/media/export.c863b12a.svg";